
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="空数据" fileName="basic.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;request()&quot;&gt;切换请求&lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; border-y /&gt;
        &lt;div v-show=&quot;showEmpty&quot; class=&quot;empty-data&quot;&gt;暂无数据&lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;center&quot;,
                        width: &quot;20%&quot;,
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;20%&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;center&quot;,
                        width: &quot;30%&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                        width: &quot;30%&quot;,
                    },
                ],
                tableData: [],
                // show empty
                showEmpty: false,
            };
        },
        methods: {
            request() {
                setTimeout(() =&gt; {
                    this.tableData =
                        this.tableData.length &gt; 0
                            ? []
                            : [
                                  {
                                      name: &quot;John&quot;,
                                      date: &quot;1900-05-20&quot;,
                                      hobby: &quot;coding and coding repeat&quot;,
                                      address: &quot;No.1 Century Avenue, Shanghai&quot;,
                                  },
                                  {
                                      name: &quot;Dickerson&quot;,
                                      date: &quot;1910-06-20&quot;,
                                      hobby: &quot;coding and coding repeat&quot;,
                                      address: &quot;No.1 Century Avenue, Beijing&quot;,
                                  },
                                  {
                                      name: &quot;Larsen&quot;,
                                      date: &quot;2000-07-20&quot;,
                                      hobby: &quot;coding and coding repeat&quot;,
                                      address: &quot;No.1 Century Avenue, Chongqing&quot;,
                                  },
                                  {
                                      name: &quot;Geneva&quot;,
                                      date: &quot;2010-08-20&quot;,
                                      hobby: &quot;coding and coding repeat&quot;,
                                      address: &quot;No.1 Century Avenue, Xiamen&quot;,
                                  },
                                  {
                                      name: &quot;Jami&quot;,
                                      date: &quot;2020-09-20&quot;,
                                      hobby: &quot;coding and coding repeat&quot;,
                                      address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                                  },
                              ];

                    if (this.tableData.length === 0) {
                        this.showEmpty = true;
                    } else {
                        this.showEmpty = false;
                    }
                });
            },
        },
        created() {
            this.request();
        },
    };
&lt;/script&gt;

&lt;style&gt;
    .empty-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
        color: #666;
        font-size: 16px;
        border: 1px solid #eee;
        border-top: 0;
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.request()}}},[_vm._v("切换请求")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"border-y":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmpty),expression:"showEmpty"}],staticClass:"empty-data"},[_vm._v("暂无数据")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        align: "center",
                        width: "20%",
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        align: "left",
                        width: "20%",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "center",
                        width: "30%",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        align: "left",
                        width: "30%",
                    },
                ],
                tableData: [],
                // show empty
                showEmpty: false,
            };
        },
        methods: {
            request() {
                setTimeout(() => {
                    this.tableData =
                        this.tableData.length > 0
                            ? []
                            : [
                                  {
                                      name: "John",
                                      date: "1900-05-20",
                                      hobby: "coding and coding repeat",
                                      address: "No.1 Century Avenue, Shanghai",
                                  },
                                  {
                                      name: "Dickerson",
                                      date: "1910-06-20",
                                      hobby: "coding and coding repeat",
                                      address: "No.1 Century Avenue, Beijing",
                                  },
                                  {
                                      name: "Larsen",
                                      date: "2000-07-20",
                                      hobby: "coding and coding repeat",
                                      address: "No.1 Century Avenue, Chongqing",
                                  },
                                  {
                                      name: "Geneva",
                                      date: "2010-08-20",
                                      hobby: "coding and coding repeat",
                                      address: "No.1 Century Avenue, Xiamen",
                                  },
                                  {
                                      name: "Jami",
                                      date: "2020-09-20",
                                      hobby: "coding and coding repeat",
                                      address: "No.1 Century Avenue, Shenzhen",
                                  },
                              ];

                    if (this.tableData.length === 0) {
                        this.showEmpty = true;
                    } else {
                        this.showEmpty = false;
                    }
                });
            },
        },
        created() {
            this.request();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .empty-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
        color: #666;
        font-size: 16px;
        border: 1px solid #eee;
        border-top: 0;
    }
    </style>
  